import { styled as styledMui, Box } from "@mui/material";

export const SIDEBAR_WIDTH = 280;
export const SIDEBAR_WIDTH_COLLAPSED = 88;

export const CollapsedIconTile = styledMui(Box)<{ active?: boolean }>(
  ({ theme, active }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "48px",
    height: "48px",
    borderRadius: "10px",
    cursor: "pointer",
    backgroundColor:
      theme.palette.action.disabledBackground || "rgba(255, 255, 255, 0.04)",
    border: active
      ? `1.5px solid ${theme.palette.primary.main}`
      : "1.5px solid transparent",
    color: theme.palette.text.primary,
    transition: "background-color 0.15s ease, border-color 0.15s ease",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      borderColor: active ? theme.palette.primary.main : theme.palette.divider,
    },
  }),
);

export const SidebarContainer = styledMui(Box)<{ width: number }>(
  ({ theme, width }) => ({
    width: `${width}px`,
    minWidth: `${width}px`,
    height: "calc(100vh - 32px)",
    position: "sticky",
    top: "16px",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "16px",
    overflowY: "auto",
    overflowX: "hidden",
    zIndex: 10,
    transition: "width 0.25s ease, min-width 0.25s ease",
    "&::-webkit-scrollbar": {
      width: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.action.disabled,
      borderRadius: "4px",
    },
  }),
);

export const SidebarHeader = styledMui(Box)({
  padding: "20px 16px 16px",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

export const SidebarBody = styledMui(Box)({
  flex: 1,
  overflowY: "auto",
  padding: "0 8px 16px",
  display: "flex",
  flexDirection: "column",
  gap: "4px",
});

export const SidebarSectionWrapper = styledMui(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  paddingTop: "8px",
});

export const SidebarSectionLabel = styledMui(Box)({
  padding: "4px 8px 6px",
});

export const SimpleItemWrapper = styledMui(Box)({
  display: "flex",
  flexDirection: "column",
});

export const SimpleItemContainer = styledMui(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  padding: "10px 16px",
  borderRadius: "10px",
  cursor: "pointer",
  transition: "background-color 0.15s ease",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const SimpleItemChildrenContainer = styledMui(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "2px",
  overflow: "hidden",
  transition: "all 0.25s ease-in-out",
});

export const SimpleItemChild = styledMui(Box)(({ theme }) => ({
  padding: "6px 8px 6px 46px",
  borderRadius: "6px",
  cursor: "pointer",
  transition: "background-color 0.15s ease",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const SimpleItemContent = styledMui(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minWidth: 0,
});

export const SimpleItemIconWrapper = styledMui(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: "20px",
  height: "20px",
  color: theme.palette.text.primary,
}));
